module.exports = __webpack_public_path__ + "static/media/13.56a42137.webp";